import { shallowEqual, useSelector } from 'react-redux';

const createSelectorFn = (slice) => () => useSelector((state) => state[slice.name], shallowEqual);
const createReducerList = (sliceList) => {
  return sliceList.reduce((acc, item) => {
    return { ...acc, [item.name]: item.reducer };
  }, {});
};

export { createSelectorFn, createReducerList };
